import { Module } from 'vuex';

import { AuditState } from '../../models';

import { ListAction } from '../../store/audit/actions/list.action';
import { AUDIT_CONSTS } from '../../store/audit/audit.consts';
import { DataGetter } from '../../store/audit/getters/data.getter';
import { SetDataMutation } from '../../store/audit/mutations/set-data.mutation';

export const AUDIT_MODULE: Module<AuditState, any> = {
  namespaced: true,

  state: (): AuditState => {
    return {
      data: {
        items: [],
        total: undefined
      }
    };
  },

  getters: {
    [AUDIT_CONSTS.getters.data]: DataGetter.execute
  },

  actions: {
    [AUDIT_CONSTS.actions.list]: ListAction.execute
  },

  mutations: {
    [AUDIT_CONSTS.mutations.setData]: SetDataMutation.execute
  }

};
